<template>
  <div class="media-report-box">
    <div class="show-flex-box-c">
      <dl class="show-flex-box-c">
        <dt class="show-flex-box-c">
          <span>媒体报道</span>
          <strong></strong>
        </dt>
       <dd class="mars-box-media slide-box">
          <div class="media-slide-box show-flex-box-r">
            <div class="slide-left show-flex-box-r"><strong class="media-prevs"></strong></div>
            <div class="media-slide media-swiper">
              <ul class="swiper-wrapper swiper-no-swiping">
                <li class="swiper-slide" v-for= "(item,index) in mediaList" :key= "index" @click="tabToLinkOut(item.url)">
                  <span><img :src="item.img" alt="德阳经开科创" draggable="false"></span>
                </li>
              </ul>
              <div class="swiper-pagination swiper-media-pagination"></div>
            </div>
            <div class="slide-right show-flex-box-r"><strong class="media-nexts"></strong></div>
          </div>
        </dd>
      </dl>
    </div>
  </div>
</template>

<script>
import "@/../static/css/swiper-4.4.1.min.css"
import Swiper from '@/../static/js/swiper-4.4.1.min.js'

export default {
  name: 'media_report_cpn',
  data () {
    return {
      mediaList: [
        {'img': require('../../assets/home/media_report/media_report_1.png'),'url': 'http://baijiahao.baidu.com/s?id=1604393659252690259&wfr=spider&for=p'},
        {'img': require('../../assets/home/media_report/media_report_2.png'),'url': 'https://www.sohu.com/a/344229217_461894'},
        {'img': require('../../assets/home/media_report/media_report_3.png'),'url': 'https://baijiahao.baidu.com/s?id=1647732411950365063&wfr=spider&for=pc'},
        {'img': require('../../assets/home/media_report/media_report_4.png'),'url': 'http://news.cnr.cn/native/lmgd/20191105/t20191105_524845406.shtml'},
      ]
    }
  },
  mounted() {
    this.initMediaSwiper();
  },
  methods: {
    initMediaSwiper: function() {
        var marsSwiper = new Swiper('.media-swiper', {
        speed: 500,
        slidesPerView: 4,
        slidesPerGroup: 4,
        spaceBetween : 8,
        noSwiping: true,
        // pagination: {
        //   el: '.swiper-media-pagination'
        // },
        navigation: {
          nextEl: '.media-nexts',
          prevEl: '.media-prevs',
        },
      });
    },
    tabToLinkOut: function(curUrl) {
      window.open(curUrl, '_blank');
    }
  }
}
</script>

<style lang="less" scoped>

  //公共字体样式  start
  .media-report-font-style( @size; @weight; @height; @color ) {
    display: block;
    font-size: @size;
    font-weight: @weight;
    line-height: @height;
    color: @color;
    word-break: break-all;
  }

  .media-report-box{
    width: 100%;
    background: #FAFAFA;
    &>div{
      margin: 0 auto;
      width: 1273px;
      align-items: center;
      &>dl{
        width: 100%;
        align-items: center;
        &>dt{
          align-items: center;
          &>span{
            word-wrap: none;
            .media-report-font-style( 40px; bold; auto; #191D21 );
            padding-top: 80px;
          }
          &>strong{
            display: block;
            width: 130px;
            height: 5px;
            background: #FF7800;
            margin-top: 19px;
            margin-bottom: 38px;
          }
        }
        &>.slide-box {
          padding-bottom: 93px;
          height: 253px;
          .media-slide-box {
            width: 1273px;
            height: 100%;
            margin: 0 auto;
            .slide-left, .slide-right{
              width: 48px;
              height: 100%;
              cursor: pointer;
            }
            .slide-left strong, .slide-right strong {
              flex-grow: 1;
              flex-shrink: 0;
              background-repeat: no-repeat;
              background-size: 18px 30px;
            }
            .slide-left strong {
              background-position: center left;
              background-image: url("../../assets/common/marsbox_hover_left.png");
            }
            .slide-right strong {
              background-position: center right;
              background-image: url("../../assets/common/marsbox_hover_right.png");
            }
            .media-slide {
              position: relative;
              overflow: hidden;
              width: 1273px;
              &>ul {
                &>li {
                  width: 296px;
                  cursor: pointer;
                  span {
                    width: 296px;
                    height: 253px;
                    img {
                      display: block;
                      width: 100%;
                    }
                  }
                }
                // &>li:hover {
                //   width: 296px;
                //   box-shadow: 1px 1px 10px 10px rgba(0,0,0,0.1);
                //   span {
                //     width: 296px;
                //     height: 253px;
                //     img {
                //       display: block;
                //       width: 100%;
                //     }
                //   }
                // }
              }
              &>.swiper-pagination {
                bottom: 0;
              }
            }
          }
        }
      }
    }
  }
</style>
<style>
/* .mars-box-media {
  position: relative;
}
.mars-box-media .swiper-pagination {
  display: flex;
  justify-content: center;
  position: absolute;
  width: 100%;
  bottom: 0;
}
.mars-box-media .swiper-pagination span {
  display: block;
  width: 50px;
  height: 2px;
  border-radius: 0;
  margin-right: 10px;
  background: #fff;
}
.mars-box-media .swiper-pagination span:last-child {
  margin-right: 0;
}
.mars-box-media .swiper-pagination span.swiper-pagination-bullet-active {
  background: #ff7800;
} */
</style>



// WEBPACK FOOTER //
// src/components/home/media_report_cpn.vue